var map = {
	"./bsu.webp": 5284,
	"./coursera.webp": 9302,
	"./freshworks.webp": 4368,
	"./isaca.webp": 8141,
	"./issa.webp": 7574,
	"./microsoft.webp": 4190,
	"./netskope.webp": 9043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4132;